// extracted by mini-css-extract-plugin
export default {"hideTooltip":"B9-z","fadeIn":"C9-z","delay":"D9-z","recommendedSizeTooltip":"E9-z"};